import _ from "lodash";

import { calculateAge } from "../../../../../utils";
import { getGenericFormInitialValues } from "../../../../../components/form/utils/initialValues";

export const getPfizerCopayOralIQVIAFormInitialValues = ({ applicationForm, formJson }) => {
  const initialValues = getGenericFormInitialValues(applicationForm, formJson);

  // Vendor-specific overlay: the caregiver Yes/No is DERIVED, not something the user answers — a
  // patient under 18 always needs a caregiver, and an already-captured caregiver implies one. The
  // generic engine has no manipulation for this, so it stays here, identical to the pre-JSON form
  // (a false result collapses to undefined so "No" isn't pre-selected). Derive from the SAVED
  // caregiver in formData, not the generic-built one — the latter always carries a phoneType default
  // and would therefore never look empty.
  const patient = applicationForm?.formData?.patient;
  const isPatientUnder18 = calculateAge(patient?.dob) < 18;
  const hasCaregiver = isPatientUnder18 || !_.isEmpty(patient?.caregiver);
  initialValues.patient.hasCaregiver = hasCaregiver || undefined;

  return initialValues;
};
